import RegisterComponent from "../../components/auth/register"

const Register = () => {
  return (
    <div>
      <RegisterComponent />
    </div>
  )
}

export default Register
